import { PARTICIPANT_NAME_SYSTEM_FRIENDLY } from 'constants/twilio';
import { AVATAR_ACTIVITY_STATE, AvatarActivityState } from './AvatarUpdate.types';

export const getContent = (name: string, state: AvatarActivityState) => {
  const advocateName = name || 'the Advocate';

  // If no advocate name is present on a "STATE_NOT_PRESENT" update, assume it is after a "STATE_IN_QUEUE" update. If name is present treat as normal "STATE_NOT_PRESENT" notification.
  const stateNotPresentText =
    state === AVATAR_ACTIVITY_STATE.NOT_PRESENT && !name
      ? `You've canceled the request to chat with an Advocate. ${PARTICIPANT_NAME_SYSTEM_FRIENDLY} can help 24/7.`
      : `The Advocate has left the conversation. ${PARTICIPANT_NAME_SYSTEM_FRIENDLY} can help if you have any more questions.`;

  const hash = {
    [AVATAR_ACTIVITY_STATE.PRESENT]: `${advocateName} has joined the conversation.`,
    [AVATAR_ACTIVITY_STATE.NOT_PRESENT]: stateNotPresentText,
    [AVATAR_ACTIVITY_STATE.DISMISSED]: "You've ended the chat with the Advocate.",
    [AVATAR_ACTIVITY_STATE.IN_QUEUE]: null,
    [AVATAR_ACTIVITY_STATE.UNKNOWN]: null,
  };

  return hash[state];
};
